<template>
  <el-dialog
    title="简历评分反馈"
    :visible.sync="dialogVisible"
    :modal="false"
    :close-on-click-modal="false"
    width="400px">
    <div class="cv-grade-feedback">
      <div class="cvfeedback-header mb10">
        <span style="margin-right:30px"><span class="feedback-bolder">当前评分</span>{{grade.评分}}分</span>
        <span>{{grade.等级}}{{grade.简历等级}}</span>
      </div>
      <div class="mb10">
        <span class="feedback-bolder mb10">您认为人选应该是：</span>
        <el-checkbox-group v-model="feedback.简历等级" class="checkbox">
          <el-checkbox v-for="val in levels" :key="val.label" :max="1" :label="val.value">{{val.label}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="mb10">
        <span class="feedback-bolder mb10">您的理由是：</span>
        <el-input
          v-model="feedback.反馈详情"
          type="textarea"
          :rows="2"
          size="mini"
          placeholder="我们会根据您的意见调整算法">
        </el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirm">确定提交</div>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      feedback: {},
      grade: {},
      levels: [
        { label: '100-80分 A+ 精品简历', value: 'A+' },
        { label: '79-59分 A 优秀简历', value: 'A' },
        { label: '58-38分 B 良好', value: 'B ' },
        { label: '37分及以下 C 一般', value: 'C' },
      ],
    }
  },
  methods: {
    async open(grade, cv) {
      this.grade = grade || {}
      this.cv = cv || {}
      this.feedback = { 简历等级: [], 反馈详情: '' }
      this.dialogVisible = true
    },
    async confirm() {
      const feedback = {
        简历等级: this.feedback.简历等级[0],
        反馈详情: this.feedback.反馈详情[0],
      }
      if (!feedback.简历等级) return this.$message.error('请选择您心目中的简历等级')
      if (!feedback.反馈详情) return this.$message.error('请描述一下反馈的详情，方便我们改进')

      if (this.loading) return this.$message.error('保存中，请稍等')
      this.loading = true

      const res = await app.service('company').addCvGradeFeedback({ md5: this.cv.md5, feedback: feedback })
      if (res.status === 'success') {
        this.$message.success('反馈成功')
        this.dialogVisible = false
      } else this.$message.error(res.msg)
      this.loading = false
    },
  },
}
</script>
<style scoped>
.feedback-bolder {
  font-weight: 700;
  font-size: 16px;
}
.checkbox {
  display: flex;
  flex-direction: column;
  padding-left: 85px;
}
</style>
